import { axiosPost } from '../ServiceBase.js';

export const findBy = async (data) => {
  const afiliado = await axiosPost('v1/busquedas/afiliados/buscar', data);
  return afiliado;
};
